import { Component, Injector, Input, SimpleChange, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Company, DeviceViews, InteractiveContent, PolicyDetail, SearchType, UserActionType, UserActionValue } from 'models';
import { environment } from 'src/environments/environment';
import { BaseComponent } from 'src/_base/base/base.component';
import { ProductListSelectedFilters } from './products-list-filters/products-list-filters.component';
import { BrowserConfig, DeviceViewService, LoginService } from 'src/_services';
import { TutorService } from 'src/app/_tutor/tutor.service';
import { Console } from 'node:console';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Observable, of } from 'rxjs';




const ProductList_Columns = {
  CARATTGEN_COLUMNS: ['Name', 'SocietyName', 'Class', 'MinSinglePremium', 'IsPartialRefund'],
  COPERTASS_COLUMNS: ['Name', 'SocietyName', 'Duration', 'IsInjury', 'IsConvertible'],
  PRESTZFIN_COLUMNS: ['Name', 'SocietyName', 'InvestTrgt', 'RiskGrade']
}

type ColumnList = ('CARATTGEN_COLUMNS' | 'COPERTASS_COLUMNS' | 'PRESTZFIN_COLUMNS');
enum GroupHeader {
  minRacc,
  rendimentoAnnuoAtteso
}

@Component({
  selector: 'app-products-list',
  templateUrl: './products-list.component.html',
  styleUrls: ['./products-list.component.css'],
})
export class ProductsListComponent extends BaseComponent {
  userData$: Observable<any> = of({});
  @Input() products!: PolicyDetail[];
  @Input() resultsFrom: SearchType;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  
  isAuthenticated = false;

  // columns: string[] = ProductList_Columns.CARATTGEN_COLUMNS;
  columns: string[] = ['Name', 'SocietyName', 'Class', 'SuggestedPeriod', 'AnnualCost', 'rendattesi','MinSinglePremium', 'Duration', 'InvestTrgt', 'RiskGrade','IsConvertible']
  espandiColumns: string[] = ['Name', 'SocietyName', 'Class', 'SuggestedPeriod', 'AnnualCost', 'rendattesi','MinSinglePremium', 'Duration', 'InvestTrgt', 'RiskGrade','IsConvertible']
  nascondiColumns : string[] = ['Name', 'SocietyName', 'Class', 'SuggestedPeriod', 'AnnualCost','ScenarioModerato', 'ScenarioFavorevole' , 'ScenarioSfavorevole', 'StressScenario','MinSinglePremium', 'Duration', 'InvestTrgt', 'RiskGrade','IsConvertible']
  selectedColumnList: ColumnList = 'CARATTGEN_COLUMNS';
  dataSource: MatTableDataSource<PolicyDetail>

  isFiltersShown: boolean = false;
  companies: Company[];

  deviceView: DeviceViews = 'desktop';

  RendAttesiView : 'nascondi'| 'espandi' = 'espandi';


  groupHeader = GroupHeader;

  constructor(
    private inj: Injector,
    private _deviceView: DeviceViewService,
    private oidcSecurityService: OidcSecurityService,
    private _login: LoginService,
    private tutor: TutorService
  ) {
    super(inj);
    this.dataSource = new MatTableDataSource<PolicyDetail>(this.products ?? []);
    this.userData$ = this.oidcSecurityService.userData$;
    this.oidcSecurityService.isAuthenticated$.subscribe(
      ({ isAuthenticated }) => {
        this.isAuthenticated = isAuthenticated;
        
        console.warn('authenticated: ', isAuthenticated);
      }
    );
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  ngAfterContentChecked() {
    this.deviceView = this._deviceView.getDeviceView();
  }
  
  ngOnChanges(changes: SimpleChange) {
    if (changes["products"] && this.products) {
      this.products.forEach(product => {
        product.RiskGrade = this.getRiskGradeTblValue(product);
        product.InvestTrgt = this.getInvestmentTargetTblValue(product);
      })

      this.products = this.products.sort((a, b) => {
        if (a.RiskGradeMax == b.RiskGradeMax) {
          if (a.RiskGradeMin == b.RiskGradeMin) {
            const aMinSinglePremium = a.MinSinglePremium != null && a.MinSinglePremium > -1 ? a.MinSinglePremium : 1000000;
            const bMinSinglePremium = b.MinSinglePremium != null && b.MinSinglePremium > -1 ? b.MinSinglePremium : 1000000;
  
            if (aMinSinglePremium == bMinSinglePremium) {
              return a.Name.localeCompare(b.Name)
            }
  
            return aMinSinglePremium - bMinSinglePremium
          }
          
          return a.RiskGradeMin - b.RiskGradeMin
        }

        return a.RiskGradeMax - b.RiskGradeMax
      })
      this.dataSource = null;
      this.products = [...this.products];
      this.dataSource = new MatTableDataSource<PolicyDetail>(this.products);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }
  }

  changeCols(cols: ColumnList) {
    this.selectedColumnList = cols;
    this.columns = ProductList_Columns[cols];
  }

  applyFitlers(selectedFilters: ProductListSelectedFilters) {
    if (selectedFilters && this.products) {
      let _products = [...this.products];
      _products = _products.filter(x => {
        if (selectedFilters.companies != null && selectedFilters.companies.length > 0 && !selectedFilters.companies.includes(x.SocietyCode.toString())) return false
        if (selectedFilters.ramiVita != null && selectedFilters.ramiVita.length > 0 && !selectedFilters.ramiVita.includes(x.Class)) return false
  
        if (selectedFilters.maxRiskGrade != null && selectedFilters.maxRiskGrade.toString() != 'null' && x.RiskGradeMax > selectedFilters.maxRiskGrade) return false
        if (selectedFilters.minPremium != null && selectedFilters.minPremium.toString() != 'null' && x.MinSinglePremium != selectedFilters.minPremium) return false
        if (selectedFilters.investTrgt != null && selectedFilters.investTrgt != 'null' && x.InvestTrgt != selectedFilters.investTrgt) return false
        if (selectedFilters.suggPeriod != null && selectedFilters.suggPeriod != 'null' && (x.SuggestedPeriod != null && x.SuggestedPeriod != '' ? parseInt(x.SuggestedPeriod) : 0) < parseInt(selectedFilters.suggPeriod)) return false
  
        return true
      });
  
      this.dataSource = new MatTableDataSource<PolicyDetail>(_products);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }
  }

  goToProductPage(p: PolicyDetail) {
    if(p != null) {
      let baseDomain: string = BrowserConfig.redirectPolicyDetail ? BrowserConfig.redirectPolicyDetail :  BrowserConfig.baseDomain.toString();
      if(!baseDomain.endsWith('/')) { baseDomain = `${baseDomain}/` };
      window.open(`${baseDomain}/policy/${p.FidaCode}`, '_blank');
    }
  }

  getProductPageUrl(p: PolicyDetail): string {
    if(p != null) {
      let baseDomain: string = BrowserConfig.redirectPolicyDetail ? BrowserConfig.redirectPolicyDetail :  BrowserConfig.baseDomain.toString();
      if(!baseDomain.endsWith('/')) { baseDomain = `${baseDomain}/` };
      return `${baseDomain}/policy/${p.FidaCode}`
    }

    return '/'
  }

  getCompanyLogoUrl(p: PolicyDetail): string {
    if (p) {
      let baseDomain: string = BrowserConfig.baseDomain ?? '';
      if (baseDomain?.charAt(baseDomain.length - 1) == '/') { baseDomain = baseDomain.slice(0, baseDomain.length - 1); }

      const societyName = p.SocietyName?.replace(/ /g, '-') ?? '';
      return `${baseDomain}/assets/loghi/${p.SocietyCode}-${societyName}.png`
    }

    return ''
  }
  
  getRiskGradeTblValue(product: PolicyDetail): string {
    if (product != null) {
      const min = product?.RiskGradeMin > 0 ? product.RiskGradeMin : 1;
      const max = product?.RiskGradeMax > 0 ? product.RiskGradeMax : 1;
      return `${min} - ${max}`
    }

    return '-'
  }

  getInvestmentTargetTblValue(product: PolicyDetail): string {
    if (product?.IsTMPreserve) return 'Conserv. capitale'
    if (product?.IsTMIncome) return 'Reddito'
    if (product?.IsTMGrowth) return 'Increm. capitale'

    return '-'
  }

  getGroupHeaderCols(): string[] {
    let cols: string[] = [];

    let suggPeriodIndex: number = this.columns.findIndex(x => x == 'SuggestedPeriod');
    let ScenarioModeratoIndex: number = this.columns.findIndex(x => x == 'rendattesi');
    let AnnualCostIndex: number = this.columns.findIndex(x => x == 'AnnualCost');
    const colspanMinRacc = 3;
    const colsapnRendimentoAnnuoAtteso = 3;
    //console.log("Columns: "+JSON.stringify(this.columns))
    for (let i = 0; i < this.columns.length; i++) {
      //["Name","SocietyName","Class","SuggestedPeriod","AnnualCost","rendattesi","MinSinglePremium","Duration","InvestTrgt","RiskGrade","IsConvertible"]

      if (i == suggPeriodIndex) {
        cols.push('minRacc');
      }
      /*
      else if(i == ScenarioModeratoIndex-1){
        cols.push('nascondi-espandi')
      }
        */
        
      else if (i == AnnualCostIndex && this.RendAttesiView == 'nascondi') {
        cols.push('rendimentoAnnuoAtteso');
      }
      else if(this.RendAttesiView == 'espandi'){
        if (i <= this.columns.length-colsapnRendimentoAnnuoAtteso) {
         
        
         cols.push(i == 1 ? 'stickyEmptyPlaceholder' : 'emptyPlaceholder')
         
          
        }
      }
      else {
        
        if(cols[cols.length-1] == "AnnualCost") continue;
        if(i < this.columns.length-colsapnRendimentoAnnuoAtteso-1)
        cols.push(i == 1 ? 'stickyEmptyPlaceholder' : 'emptyPlaceholder')
       
        
      }
      
    }
    //console.log("cols: "+JSON.stringify(cols))
    return cols
  }

  openTblGroupHeaderDesc(group: GroupHeader) {
    let title: string = '';
    let desc: string = '';

    switch (group) {
      case GroupHeader.minRacc: 
        title = 'Durata raccom.';
        desc = "<p>Durata minima di detenzione raccomandata dall'emittente. Su questo periodo l'emittente calcola il costo omnicomprensivo del prodotto espresso su base annua. L'indicazione non è vincolante per l'eventuale esercizio del riscatto anticipato.</p>";
      break;

      case GroupHeader.rendimentoAnnuoAtteso:
        // TODO: Aggingere nuove colonne per il rendimento Annuo Atteso dopo che la parte backend è stata sviluppata
        title = "Rendimento annuo atteso"
        desc = "<p>Possibile rendimento annuo del capitale investito, al netto di tutti i costi, nell'ambito del periodo di detenzione raccomandato dall'emittente e declinato nei quattro scenari previsti nel KID.</p>"
      break;
    }
    
    const dialogTxt: InteractiveContent[] = [
      {
        typo: 'html',
        str: desc
      },
      { typo: 'break' },{ typo: 'break' },
      {
        typo: 'click',
        str: 'Chiudi',
        value: 0
      }
    ];

    const userActions: UserActionValue[] = [{action: {type: UserActionType.ignore}, value: 0}]

    this.tutor.showText('', title, false, dialogTxt, userActions, 'info')
  }

  clickrendAttesi(){
    if(this.isAuthenticated){
      if (this.RendAttesiView == 'nascondi'){
        this.RendAttesiView = 'espandi'
        this.columns = this.espandiColumns
      } 
      else {
        this.RendAttesiView = 'nascondi'
        this.columns = this.nascondiColumns
      }
    }
    else{this._login.showLoginIsRequiredMsg();}
  }

  showRecurPremim(element : PolicyDetail){
    if(element.RecurPremium) {
      const dialogTxt:InteractiveContent[] = [
        {
          typo: 'html',
          str: "Premio ricorrente: "+element.RecurPremium
        },
        { typo: 'break' },{ typo: 'break' },
        {
          typo: 'click',
          str: 'Chiudi',
          value: 0
        }
      ];
  
      const userActions: UserActionValue[] = [{action: {type: UserActionType.ignore}, value: 0}]
  
      this.tutor.showText('', element.Name, false, dialogTxt, userActions, 'info')
    }
  }

}
